import { AnyAction, Middleware, MiddlewareAPI } from 'redux';

export class ActionHistoryReduxMiddleware {
  static readonly MAX_HISTORY_SIZE = 35;
  private readonly actionHistory: Array<AnyAction> = [];
  private store: MiddlewareAPI;

  constructor(private readonly isRelevantAction = ActionHistoryReduxMiddleware.defaultFilter) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private static readonly defaultFilter: (action: AnyAction) => boolean = () => true;

  middleware: Middleware = store => next => (action: AnyAction) => {
    this.store = store;
    if (!this.isRelevantAction(action)) {
      return next(action);
    }
    if (this.actionHistory.length < ActionHistoryReduxMiddleware.MAX_HISTORY_SIZE) {
      this.actionHistory.push(action);
    } else {
      this.actionHistory.shift();
      this.actionHistory.push(action);
    }

    return next(action);
  };

  getActionHistory(): Array<AnyAction> {
    return this.actionHistory;
  }
}
